/* =========================================
   ISL LAB — Fix duplicate Add-to-cart buttons
   Keep ONLY the first visible button (top).
   Works even if Horizon re-renders/morphs DOM.
========================================= */

(function () {
  function isAddToCartButton(btn) {
    if (!btn) return false;

    // Common Shopify/Horizon selectors
    const byName = btn.matches('button[name="add"]');
    const byRef = btn.getAttribute('ref') === 'addToCartButton';
    const byClass = btn.classList.contains('add-to-cart') || btn.classList.contains('product-form__submit');

    // Also detect by text (FR)
    const txt = (btn.textContent || '').toLowerCase();
    const byText = txt.includes('ajouter au panier');

    return byName || byRef || byClass || byText;
  }

  function fixIn(root) {
    const scope = root && root.querySelector ? root : document;

    // We only care about product pages/forms
    const forms = scope.querySelectorAll('product-form-component, form[action*="/cart/add"]');
    if (!forms.length) return;

    forms.forEach((container) => {
      // Get ALL add-to-cart buttons inside this container
      const buttons = Array.from(container.querySelectorAll('button')).filter(isAddToCartButton);

      if (buttons.length <= 1) return;

      // Keep the first one (top). Hide/remove the rest.
      const keep = buttons[0];

      for (let i = 1; i < buttons.length; i++) {
        const b = buttons[i];

        // If it's inside a wrapper, hide the wrapper to avoid layout gaps
        const wrapper =
          b.closest('.product-form__buttons') ||
          b.closest('.product-form-buttons') ||
          b.closest('.shopify-payment-button') ||
          b.parentElement;

        if (wrapper && wrapper !== keep.parentElement) {
          wrapper.style.display = 'none';
        } else {
          b.style.display = 'none';
        }
      }
    });
  }

  function boot() {
    fixIn(document);

    // Watch DOM changes because Horizon can re-render buttons
    const obs = new MutationObserver((mutations) => {
      // Quick filter: if nothing interesting changed, skip
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) {
          fixIn(document);
          break;
        }
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();